import { getStopsWithVisitedInfo, stringifyLatLng, getCurrentStop } from 'utils/mapbox'
import {
  ETA_ACTION_TYPES,
  PREVIOUS_DIRECTIONS_ACTION_TYPES,
  PREDICTED_DIRECTIONS_ACTION_TYPES,
  getDirections,
} from '../actions/mapbox'

const { SIDEBAR_ETA } = ETA_ACTION_TYPES

export const mapbox = store => next => action => {
  if (action.type !== SIDEBAR_ETA) return next(action)
  const { payload: { shipment } = {} } = action

  const {
    driverLocationLatitude,
    driverLocationLongitude,
    status: { currentStopIndex },
    stops,
  } = shipment

  getStopsWithVisitedInfo(stops, currentStopIndex)
  const currentStop = getCurrentStop(stops, currentStopIndex)
  const previousRoute = stops.filter(stop => stop.visited)
  const predictedRoute = stops.filter(stop => !stop.visited)

  const latestLocation = {
    facility: {
      latitude: driverLocationLatitude,
      longitude: driverLocationLongitude,
    },
  }

  const currentLocation =
    driverLocationLatitude && driverLocationLongitude ? latestLocation : currentStop

  if (
    currentLocation &&
    predictedRoute[0] &&
    (currentLocation.facility.latitude !== predictedRoute[0].facility.latitude ||
      currentLocation.facility.longitude !== predictedRoute[0].facility.longitude)
  ) {
    predictedRoute.unshift({
      facility: {
        latitude: currentLocation.facility.latitude,
        longitude: currentLocation.facility.longitude,
      },
    })
  }
  if (
    currentLocation &&
    previousRoute[0] &&
    (currentLocation.facility.latitude !== previousRoute[0].facility.latitude ||
      currentLocation.facility.longitude !== previousRoute[0].facility.longitude)
  ) {
    previousRoute.push({
      facility: {
        latitude: currentLocation.facility.latitude,
        longitude: currentLocation.facility.longitude,
      },
    })
  }
  const predRouteCoords = predictedRoute.map(stringifyLatLng)
  const previousRouteCoords = previousRoute.map(stringifyLatLng)
  const stopsData = { stops, currentStopIndex }

  if (previousRouteCoords.length > 0) {
    store.dispatch(getDirections(previousRouteCoords, stopsData, PREVIOUS_DIRECTIONS_ACTION_TYPES))
  }
  return store.dispatch(
    getDirections(predRouteCoords, stopsData, PREDICTED_DIRECTIONS_ACTION_TYPES)
  )
}
